import { useTranslation } from "react-i18next";
import { SxProps, Typography, useTheme } from "@mui/material";

interface useMyLeaveBarItemProps {
  label: string;
  value: string;
  isFirst?: boolean;
  isLast?: boolean;
  onlyBar?: boolean;
}

export const useMyLeaveBarItem = ({
  label,
  value,
  isFirst,
  isLast,
  onlyBar,
}: useMyLeaveBarItemProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const formattedValue = value.replace(".", ",");

  const TooltipNode = onlyBar ? null : (
    <Typography variant="body1" color={theme.palette.white.main}>
      {t(label)}: {formattedValue}
    </Typography>
  );

  const firstStyle: SxProps = {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  };

  const lastStyle: SxProps = {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  };

  const boxCurve: SxProps = {
    ...(isFirst ? firstStyle : {}),
    ...(isLast ? lastStyle : {}),
  };

  return {
    TooltipNode,
    boxCurve,
    formattedValue,
  };
};
